import * as React from 'react';
import { Container, Header, Title, Text, Button, Icon, Footer, Left, Body, Right, List, ListItem, Content, Spinner, View, H2, H3, Separator, Card, Tab, Tabs, TabHeading, CardItem } from 'native-base';
import { Platform, Linking, WebView, StyleSheet, View as RnView, PixelRatio, Dimensions, ScrollView } from 'react-native';
import * as Print from 'expo-print';
import * as FileSystem from 'expo-file-system';
import Pdf from '../../components/pdf';
import sharer from '../../components/sharer';
import Alert from '../../components/alert';
import Constants from 'expo-constants';

import { connect } from 'react-redux';
import XDate from 'xdate';

//import * as _ from 'lodash';

import CalCalDataApi from '../../api/CalCalDataApi';
import { ISO_8601 } from 'moment';
import downloader from '../../components/downloader';

class VatDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = { periodKey: null, vatReturn: null, error: false, htmlContent: null };
	}
	componentDidMount() {
		//find out which vat period from params and lod details. May be able to show some already
		//Eg. /return/19A1/2019-02-01:2019-03-31/C
	}

	loadDetails(item) {
		CalCalDataApi.dataLoad(`vat/return/${item.periodKey}/${item.start}:${item.end}/${item.obligStatus}`, this.props.jwt, res => {
			if (res.success) {
				this.setState({ periodKey: item.periodKey, vatReturn: res.vatReturn });
			} else {
				this.setState({ periodKey: item.periodKey, error: res.error || true });
			}
		});
	}

	renderDetailsTab() {
		return this.state.pdfContent ? <Pdf pdfContent={this.state.pdfContent} htmlContent={this.state.htmlContent} /> : <Spinner style={{ flex: 1 }} />;
	}
	async getPdf(period) {
		//called when scrolling to second tab
		if (this.state.pdfContent) return;
		const path = `/reports/Vat/${period.start}:${period.end}`;
		CalCalDataApi.dataLoad(path, this.props.jwt, res => {
			__DEV__ && console.log(res);
			if (res) {
				this.setState({ pdfContent: 'data:application/pdf;base64,' + res.content, pdfRaw: res.content, htmlContent: res.html });
			}
		});
	}

	printPdf() {
		Print.printAsync({ uri: this.state.pdfContent });
	}

	async download(when) {
		downloader(this.state.pdfRaw, `VAT report ${when}`);
	}

	sendReturn(oblig) {
		Alert.alert(
			'Submitting: ' + fD(oblig.start) + ' to ' + fD(oblig.end, true),
			`When you submit this VAT information you are making a legal declaration that the information is true and complete. A false declaration can result in prosecution.`,
			[
				{ text: 'Accept and finalise this VAT return', onPress: () => this.actuallySubmitReturn(oblig) },
				{ text: 'Cancel', onPress: () => console.log('Cancel Pressed'), style: 'cancel' }
			],
			{ cancelable: true }
		);
	}
	async actuallySubmitReturn(oblig) {
		var { height, width } = Dimensions.get('window');
		var { sHeight, sWidth } = Dimensions.get('screen');
		const { params } = this.props.route;
		const values = {
			periodKey: oblig.periodKey,
			start: oblig.start,
			end: oblig.end,
			tz: new Date().getTimezoneOffset(),
			screen: 'width=' + sWidth + '&height=' + sHeight + '&scaling-factor=' + PixelRatio.get() + '&colour-depth=undefined',
			window: 'width=' + width + '&height=' + height,
			os: Platform.OS + '/' + Platform.Version + ' (' + Constants.deviceYearClass + '/' + Constants.deviceName + ')', //OS Family/OS Version+ (Device Manufacturer/Device Model+)
			ua: Constants.appOwnership + '-' + Constants.installationId + '-' + Constants.nativeAppVersion,
			ver: Constants.manifest.version
		};

		CalCalDataApi.dataInsert('vat/return', values, this.props.jwt, res => {
			//console.log('handleSubmit ',res)
			if (res.success) {
				const extraMsg = res.message ? '\n' + res.message : '';
				Alert.alert(
					'Submitted',
					'Your VAT return has been submitted.\n \nIt may take up to one working day for this to be reflected here, but the data will be refreshed in a few seconds. ' + extraMsg
				);
				//params.doRefresh();
				this.props.navigation.goBack();
			} else {
				const error = res.error || res.title || res.status;
				Alert.alert('Error', 'Your return could not be submitted at this time.\n\n' + error);
			}
		});
	}

	render() {
		const { params } = this.props.route;
		const { item } = params;
		const { periodKey, obligStatus, start, end, obligLiable, obligDue, paid } = item;
		if (this.state.periodKey != periodKey) this.loadDetails(item);
		const { width, height } = Dimensions.get('window');

		const { vatReturn, error } = this.state;

		return (
			<Container>
				<Header hasTabs>
					<Left>
						<Button transparent onPress={() => this.props.navigation.goBack()}>
							<Icon name="ios-arrow-back" />
						</Button>
					</Left>
					<Body>
						<Title>VAT Period</Title>
						<Text note style={{ color: '#EEE' }}>
							{fD(start)} to {fD(end, true)}
						</Text>
					</Body>
					<Right />
				</Header>

				{!!error ? (
					<Card>
						<CardItem header>
							<Text style={{ color: '#711', fontWeight: 'bold' }}>Error</Text>
						</CardItem>
						<CardItem style={{ flexDirection: 'column' }}>
							<H3>{error}</H3>
							<Text>You can go back and try again.</Text>
						</CardItem>
					</Card>
				) : (
					<Tabs
						locked
						initialPage={0}
						onChangeTab={t => {
							t.i == 1 && this.getPdf(item);
						}}>
						<Tab heading="Summary">
							{!!vatReturn ? (
								<>
									<Card>
										<CardItem bordered>
											{obligStatus == 'C' && <H3>This is your ongoing summary for the current period</H3>}
											{obligStatus == 'S' && <H3>These are the figures you submitted</H3>}
											{obligStatus == 'O' && (
												<Text style={{ fontWeight: '400', fontSize: 18, color: '#911' }}>
													Submission Due <Text style={{ fontWeight: '600', color: '#911' }}>{fD(obligDue)}</Text>
												</Text>
											)}
										</CardItem>
										<List>
											{vatReturn.map((row, i, ps) => (
												<ListItem icon noIndent key={i} style={{ marginLeft: 0, marginBottom: -6, marginTop: -2, height: 44, padding: 0 }}>
													<Left>
														<Text style={{ fontSize: 16 }}>{row.posn}</Text>
													</Left>
													<Body>
														<Text style={{ fontSize: 14, fontWeight: row.summary ? 'bold' : 'normal' }}>{row.desc}</Text>
													</Body>
													<Right style={{}}>
														<Text style={{ fontWeight: row.summary ? 'bold' : 'normal' }}>{row.value}</Text>
													</Right>
												</ListItem>
											))}
										</List>
										{obligStatus == 'O' && (
											<CardItem bordered style={{ alignItems: 'center' }}>
												<Button
													style={{ width: '100%', alignItems: 'center' }}
													onPress={() => {
														this.sendReturn(item);
													}}>
													<Text style={{ textAlign: 'center' }}>Submit</Text>
												</Button>
											</CardItem>
										)}
									</Card>
									<Card>
										{(obligStatus == 'S' || obligStatus == 'F') && (
											<>
												<CardItem bordered>
													<Icon style={{ color: 'green' }} name="checkmark-circle" />
													<Text>Submitted</Text>
												</CardItem>
												<CardItem bordered>
													<Icon style={{ color: obligStatus == 'F' ? 'green' : 'grey' }} name={obligStatus == 'F' ? 'checkmark-circle' : 'radio-button-off'} />
													<Text style={{ color: obligStatus == 'F' ? 'black' : 'grey' }}>Confirmed</Text>
												</CardItem>
											</>
										)}
										{!!item.obligSubNotification && (
											<CardItem bordered>
												<Icon style={{ color: 'green' }} name="checkmark-circle" />
												<Text>{item.obligSubNotification}</Text>
											</CardItem>
										)}

										{!!item.obligStillONotification && (
											<CardItem>
												<Icon style={{ color: 'red' }} name="alert" />
												<Text>{item.obligStillONotification}</Text>
											</CardItem>
										)}

										{!!item.obligPayNotification && (
											<CardItem>
												<Icon style={{ color: 'orange' }} name="information-circle-outline" />
												<Text>{item.obligPayNotification}</Text>
											</CardItem>
										)}

										{!!item.obligBundleNotification && (
											<CardItem>
												<Icon style={{ color: 'blue' }} name="information-circle-outline" />
												<Text>{item.obligBundleNotification}</Text>
											</CardItem>
										)}

										{!!item.liabilityOutstanding && !item.obligPayNotification && (
											<CardItem>
												<Icon style={{ color: 'blue' }} name="information-circle-outline" />
												<Text>{'Outstanding amount £' + item.liabilityOutstanding + ' due by ' + item.liabilityDue}</Text>
											</CardItem>
										)}
									</Card>
								</>
							) : (
								<Text>Loading</Text>
							)}
						</Tab>
						<Tab heading="Details" style={{ height: height - 150 }}>
							{this.renderDetailsTab()}
							<Footer style={styles.footer}>
								{!!this.state.pdfContent && !this.state.downloading && (
									<>
										<Left>
											<Button style={styles.bottomButton} onPress={() => this.download(`${start}-${end}`)}>
												<Icon name="download" style={styles.bottomIcon} />
											</Button>
										</Left>
										{Platform.OS != 'web' && (
											<Right>
												<Button style={styles.bottomButton} onPress={() => this.printPdf()}>
													<Icon name="print" style={styles.bottomIcon} />
												</Button>
											</Right>
										)}
									</>
								)}
							</Footer>
						</Tab>
					</Tabs>
				)}
			</Container>
		);
	}
}

const fD = (dat, showYr = false) => new XDate(dat).toString(showYr ? 'd MMM yyyy' : 'd MMM');

const styles = StyleSheet.create({
	green: {
		color: 'green'
	},
	red: {
		color: 'orange'
	},
	bottomButton: {
		alignSelf: 'center',
		backgroundColor: '#295670',
		//paddingVertical: 20,
		flex: 1,
		justifyContent: 'center'
	}
});

const mapStateToProps = state => ({
	vatReg: state.globalReducer.busDetails.vatRegistered,
	jwt: state.loginReducer.jwt && state.loginReducer.jwt.token,
	user: state.loginReducer.userInfo && state.loginReducer.userInfo.user
});

export default connect(mapStateToProps)(VatDetails);
